import React, { useEffect, useState } from 'react';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import OverlayLoading from '../../../../../Components/OverlayLoading';
import { useEffectAsync } from '../../../../../helpers';
import apiClient from '../../../../../Services/ApiClient';
import UnfinishedItem from './UnfinishedItem';
import Text from '../../../../../Components/Base/Text/Text';
import UnfinishedDPNFilter, { UnfinishedDPNFilterValues } from './UnfinishedDPNFilter';

// @ts-ignore
import styles from './UnfinishedDPN.module.scss';
import { isAllowed } from '../../../../../Services/acl.service';

interface Props {
  userId: string
}

const WRAPPER_ID = 'unfinishedDPN';

const UnfinishedDPN: React.FC<Props> = props => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [items, setItems] = useState<object[]|undefined>(undefined);

  const handleFilter = async (values: UnfinishedDPNFilterValues) => {
    const filterParams = [];
    for(const filterKey of Object.keys(values)) {
      // @ts-ignore
      if(typeof values[filterKey] !== 'undefined') {
        filterParams.push(filterKey + '=' + values[filterKey]);
      }
    }
    const tmpItems = await apiClient.get('/nczi/unfinished-dpn/' + (filterParams.length ? '?' + filterParams.join('&') : ''));
    setItems(tmpItems.data || []);
  }

  useEffectAsync(async () => {
    const tmpItems = await apiClient.get('/nczi/unfinished-dpn/');
    setItems(tmpItems.data || []);
    setIsLoading(false);
  });

  if(!isAllowed('patient_health_ezdravie')) {
    return (
      <></>
    );
  }

  return (
    <div className={styles.wrapper}>
      <UnfinishedDPNFilter onFilter={handleFilter} />
      <ScrollContainer wrapperId={WRAPPER_ID}>
        {isLoading && <OverlayLoading />}
        {!(items || []).length && <div className={styles.noItemsFound}>
          <Text tx={'nczi.noItemsFound'} />
        </div>}
        {(items || []).map((item, index) => {
          return <UnfinishedItem key={index} item={item} />
        })}
      </ScrollContainer>
    </div>
  );
};

export default UnfinishedDPN;
